<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-dept
            type="search"
            label="작성 부서"
            name="deptCd"
            v-model="searchParam.deptCd">
          </c-dept>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-datepicker
            :range="true"
            :isToyear="true"
            label="작성일"
            name="period"
            v-model="period"
          />
        </div>
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <c-table
          ref="table"
          title="대기일지 목록"
          tableId="processManual"
          :columns="grid.columns"
          :gridHeight="grid.height"
          :data="grid.data"
          :columnSetting="false"
          :isFullScreen="false"
          :usePaging="false"
          :expandAll="true"
          @linkClick="linkClick"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn label="신규" icon="add" @btnClicked="linkClick" />
              <c-btn label="검색" icon="search" @btnClicked="getList" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
// import selectConfig from '@/js/selectConfig';
export default {
  name: 'daily-air-report-manage',
  data() {
    return {
      grid: {
        columns: [
          {
            name: 'col1',
            field: 'col1',
            label: '사업장',
            align: 'center',
            sortable: true,
          },
          {
            name: 'col2',
            field: 'col2',
            label: '작성일',
            align: 'center',
            sortable: true,
            type: 'link'
          },
          {
            name: 'col3',
            field: 'col3',
            label: '작성상태',
            align: 'center',
            sortable: true,
          },
          {
            name: 'col4',
            field: 'col4',
            label: '결재상태',
            align: 'center',
            sortable: true,
          },
          {
            name: 'col5',
            field: 'col5',
            label: '날씨',
            align: 'center',
            sortable: true,
          },
          {
            name: 'col6',
            field: 'col6',
            label: '온도',
            align: 'center',
            sortable: true,
          },
          {
            name: 'col7',
            field: 'col7',
            label: '작성부서',
            align: 'center',
            sortable: true,
          },
          {
            name: 'col8',
            field: 'col8',
            label: '작성자',
            align: 'center',
            sortable: true,
          },
        ],
        data: [],
      },
      searchParam: {
        startYmd: '',
        endYmd: '',
        plantCd: '',
        deptCd: '',
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        isFull: true,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.getList();
    },
    getList() {
      this.grid.data = [
        {
          col1: '사업장1', 
          col2: '2021-01-05', 
          col3: '작성중', 
          col4: '', 
          col5: '맑음', 
          col6: '12', 
          col7: '안전환경팀', 
          col8: '관리자', 
        },
        {
          col1: '사업장1', 
          col2: '2021-01-04', 
          col3: '작성중', 
          col4: '결재중', 
          col5: '비', 
          col6: '10', 
          col7: '안전환경팀', 
          col8: '관리자', 
        },
        {
          col1: '사업장1', 
          col2: '2021-01-03', 
          col3: '작성완료', 
          col4: '결재완료', 
          col5: '맑음', 
          col6: '13', 
          col7: '안전환경팀', 
          col8: '관리자', 
        },
      ];
    },
    linkClick(row) {
      this.detailPopup(row);
    },
    detailPopup(result) {
      this.popupOptions.target = () => import(`${"./dailyAirReportManageDetail.vue"}`);
      this.popupOptions.title = '대기일지 상세';
      this.popupOptions.param = {
        psiDocumentId: result,
      };
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
